"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redemeedRewardsModalModule = void 0;
const moduleIds_1 = require("root/src/client/web/giveaway/descriptions/modules/moduleIds");
exports.redemeedRewardsModalModule = {
    [moduleIds_1.giveawayModuleIds.REDEEMED_REWARDS_MODAL_MODULE_ID]: {
        moduleType: 'modal',
    },
};
